/**
 * The five-cluster content taxonomy (LL-0015, Happenings era).
 *
 * One vocabulary for every consumer: post frontmatter (`clusterTag:`), the
 * PostHog `cluster_tag` super-property (ClusterTagBinder), and the GSC
 * cluster rules in the content engine's brand config
 * (the-prompt-house-app/brands/letsloop/config.json) — keep that file in
 * lockstep when this changes.
 *
 * This is deliberately NOT a route→cluster path table. The previous one
 * (lib/clusterTag.ts, removed 2026-08-01) listed only housing-era routes,
 * drifted silently when those routes were deleted, and tagged 100% of live
 * traffic null. Clusters live in the CONTENT (frontmatter), so a post can
 * never ship without one and a route change can never orphan the mapping.
 *
 *  - meet-people:  problem-aware guides (make friends at 30, new city, ...)
 *  - things-to-do: activity/discovery content (Victoria Park, Saturday night)
 *  - communities:  recurring groups, turning meetups into friend groups
 *  - product:      LetsLoop itself (how it works, safety, download)
 *  - news:         company/product announcements and event recaps
 */
export const CLUSTER_TAGS = [
  "meet-people",
  "things-to-do",
  "communities",
  "product",
  "news",
] as const;

export type ClusterTag = (typeof CLUSTER_TAGS)[number];

/** Narrow an arbitrary frontmatter string to the taxonomy, else null. */
export function asClusterTag(
  value: string | null | undefined,
): ClusterTag | null {
  return CLUSTER_TAGS.includes(value as ClusterTag)
    ? (value as ClusterTag)
    : null;
}
